import { checkFormValid } from '../../../scripts/utils/checkFormValid';
import Logger from '../../../scripts/config/logger';
import { SENTRY_ERRORS } from '../../../scripts/config/constants';

export function contactUsFormInit() {
  const formId = 'contact_form';
  const form = document.getElementById(formId);

  form.setAttribute('novalidate', 'true');

  form.addEventListener('submit', (event) => {
    event.preventDefault();
    const submitBtn = form.querySelector('[type="submit"]');

    setValueToHiddenFields();

    checkFormValid(formId)
      .then((data) => {
        if (submitBtn) {
          submitBtn.disabled = true;
        }
        const options = {
          method: 'POST',
          body: JSON.stringify(data),
        };

        return fetch(`${form.dataset.submitUrl}`, options)
          .then((response) => {
            if (submitBtn) {
              submitBtn.disabled = false;
            }

            if (!response.ok) {
              return Promise.reject(
                new Error(`Response status ${response.status}`)
              );
            }
            return Promise.resolve(response);
          })
          .then(() => {
            showResult(true);
          })
          .catch((error) => {
            showResult(false);
            Logger.error(error, SENTRY_ERRORS.REQUEST_DEMO);
          });
      })
      .catch((error) => console.error(error));
  });

  function showResult(isSuccess) {
    const resultContainer = document.querySelector(
      '[data-contact-form-result]'
    );

    if (isSuccess) {
      resultContainer.setAttribute('data-contact-form-result', 'success');
    } else {
      resultContainer.setAttribute('data-contact-form-result', 'error');
    }
  }

  function makeUtmValue(fieldName) {
    return window.sessionStorage.getItem(fieldName) || '';
  }

  function setValueToHiddenFields() {
    const fieldNamesToValuesMap = {
      timestamp: new Date().toISOString(),
      referrer_link: document.referrer,
      utm_source: makeUtmValue('utm_source'),
      utm_campaign: makeUtmValue('utm_campaign'),
      utm_medium: makeUtmValue('utm_medium'),
      utm_term: makeUtmValue('utm_term'),
      utm_content: makeUtmValue('utm_content'),
    };

    const hiddenFields = form.querySelectorAll(`[type=hidden]`);

    if (hiddenFields) {
      hiddenFields.forEach((field) => {
        const fieldCustomValue = String(
          fieldNamesToValuesMap[field.name] || ''
        );

        if (fieldCustomValue) {
          // eslint-disable-next-line no-param-reassign
          field.value = fieldCustomValue;
        }
      });
    }
  }
}
